var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"area-container"},[_c('AreaTable',{attrs:{"tableData":_vm.tableData,"totalCount":_vm.totalCount,"downloadUrl":"/dataModule/areaInfoDownload"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }